module.exports = __webpack_public_path__ + "static/media/about-banner.9f137d1a.jpg";